export default "__VITE_ASSET__CvW5rgfR__"